import { Link } from 'react-router-dom';
import { ArrowRight, CalendarDays, Files, FolderKanban } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { usePermissions } from '@/hooks/use-permissions';

export function StartPage() {
  const { hasCapability, isLoading } = usePermissions();

  return (
    <div className="mx-auto w-full max-w-5xl space-y-6 p-6">
      <div className="space-y-2">
        <h1 className="text-2xl font-bold text-foreground">Choose a module</h1>
        <p className="text-muted-foreground">
          Start in WeTicket for customer service work, open WePlanning for weekly planning, or open
          WeWorkGroups for shared files.
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <Link to="/dashboard" className="group">
          <Card className="h-full border-border transition-colors group-hover:border-primary/50">
            <CardHeader className="space-y-2">
              <div className="flex items-center gap-2 text-foreground">
                <FolderKanban className="h-5 w-5" />
                <CardTitle>WeTicket</CardTitle>
              </div>
              <CardDescription>
                Existing ticket and customer service module.
              </CardDescription>
            </CardHeader>
            <CardContent className="flex items-center text-sm text-muted-foreground">
              Open WeTicket
              <ArrowRight className="ml-2 h-4 w-4" />
            </CardContent>
          </Card>
        </Link>

        {!isLoading && hasCapability('planning.view') && (
          <Link to="/planning" className="group">
            <Card className="h-full border-border transition-colors group-hover:border-primary/50">
              <CardHeader className="space-y-2">
                <div className="flex items-center gap-2 text-foreground">
                  <CalendarDays className="h-5 w-5" />
                  <CardTitle>WePlanning</CardTitle>
                </div>
                <CardDescription>
                  Weekly planning and production logging module.
                </CardDescription>
              </CardHeader>
              <CardContent className="flex items-center text-sm text-muted-foreground">
                Open WePlanning
                <ArrowRight className="ml-2 h-4 w-4" />
              </CardContent>
            </Card>
          </Link>
        )}

        {!isLoading && hasCapability('workgroups.view') && (
          <Link to="/workgroups" className="group">
            <Card className="h-full border-border transition-colors group-hover:border-primary/50">
              <CardHeader className="space-y-2">
                <div className="flex items-center gap-2 text-foreground">
                  <Files className="h-5 w-5" />
                  <CardTitle>WeWorkGroups</CardTitle>
                </div>
                <CardDescription>Shared files and folders for internal teams.</CardDescription>
              </CardHeader>
              <CardContent className="flex items-center text-sm text-muted-foreground">
                Open WeWorkGroups
                <ArrowRight className="ml-2 h-4 w-4" />
              </CardContent>
            </Card>
          </Link>
        )}

        {isLoading && (
          <Card className="h-full border-border">
            <CardHeader>
              <CardTitle className="text-base">Checking module access…</CardTitle>
              <CardDescription>Loading your capabilities.</CardDescription>
            </CardHeader>
          </Card>
        )}
      </div>
    </div>
  );
}
